(function () {
  function parseBool(v) {
    return String(v) === 'true';
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  class MultiContent extends HTMLElement {
    constructor() {
      super();
      this._inited = false;
      this._swiper = null;
      this._onResize = this._onResize.bind(this);
    }

    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      window.addEventListener('resize', this._onResize);
      this._maybeInit();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      this._destroy();
      this._inited = false;
    }

    _onResize() {
      this._maybeInit();
    }

    _maybeInit() {
      const enable = parseBool(this.dataset.enable);
      if (!enable || !isMobile() || !window.Swiper) {
        this._destroy();
        return;
      }

      if (this._swiper) return;

      const spacing = parseInt(this.dataset.spacing || '0', 10) || 0;
      const slidesPerView = parseFloat(this.dataset.mobile || '1') || 1;
      const freeMode = parseBool(this.dataset.freeScroll);
      const paginationClass = this.dataset.customPagination;

      this.classList.add('swiper');

      let wrapper = this.querySelector(':scope > .swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        const children = Array.from(this.children);
        children.forEach((child) => {
          if (child.classList && child.classList.contains('swiper-pagination')) return;
          child.classList.add('swiper-slide');
          wrapper.appendChild(child);
        });
        this.appendChild(wrapper);
      }

      let paginationEl = null;
      if (paginationClass) {
        paginationEl = this.querySelector('.' + paginationClass);
        if (!paginationEl) {
          paginationEl = document.createElement('div');
          paginationEl.className = 'swiper-pagination ' + paginationClass;
          this.appendChild(paginationEl);
        }
      } else {
        paginationEl = this.querySelector('.swiper-pagination');
        if (!paginationEl) {
          paginationEl = document.createElement('div');
          paginationEl.className = 'swiper-pagination';
          this.appendChild(paginationEl);
        }
      }

      this._swiper = new window.Swiper(this, {
        slidesPerView: slidesPerView,
        spaceBetween: spacing >= 15 ? 15 : spacing,
        speed: 500,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        freeMode: freeMode ? { enabled: true, momentumRatio: 0.8 } : false,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
        a11y: { enabled: true },
      });
    }

    _destroy() {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }

      // Best-effort restore DOM if we wrapped children
      const wrapper = this.querySelector(':scope > .swiper-wrapper');
      if (wrapper) {
        const slides = Array.from(wrapper.children);
        slides.forEach((slide) => {
          slide.classList.remove('swiper-slide');
          this.insertBefore(slide, wrapper);
        });
        wrapper.remove();
      }

      const paginations = this.querySelectorAll(':scope > .swiper-pagination');
      paginations.forEach((p) => p.remove());

      this.classList.remove('swiper');
    }
  }

  if (!customElements.get('multi-content')) {
    customElements.define('multi-content', MultiContent);
  }

  // Theme editor re-render safety
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e || !e.target) return;
    e.target.querySelectorAll('multi-content').forEach((el) => {
      if (el && el.disconnectedCallback) el.disconnectedCallback();
    });
  });
})();

